__turbopack_context__.v({
  "Loader": "je2hNq_Loader",
  "Loader--Small": "je2hNq_Loader--Small",
  "bounce-loader-1": "je2hNq_bounce-loader-1",
  "bounce-loader-2": "je2hNq_bounce-loader-2",
  "bounce-loader-3": "je2hNq_bounce-loader-3",
});
